import {Recurso} from 'lib.common/dist/CleanArch';
import {toast} from 'lib.front';

export async function executeUseCase<T_IN, T_OUT>({
   input,
   useCase
}: {
   useCase: {call(input: T_IN): Promise<Recurso<T_OUT>>};
   input: T_IN;
}): Promise<T_OUT | undefined> {
   try {
      const recurso = await useCase.call(input);
      if (recurso.isError()) {
         toast.showError(recurso.toString());
         return undefined;
      }
      return recurso.data;
   } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      toast.showError(message);
      return undefined;
   }
}
